import React from 'react';
import CustomerManagementTable from './components/CustomerManagementTable';

export const CustomerManagementPage = () => {
    return <CustomerManagementTable />;
};
